const defaultStore = {
  selectedDish: '',
  showEditPopup: false,
  creatingNewDish: false,
  createNewDish: false,
  editSelectedDish: false,
  dish: '',
  tags: [],
  mealTypes: [],
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'SHOW_EDIT_RECEPIE_POPUP':
      return {
        ...state,
        showEditPopup: action.data,
      };
    case 'SET_DISH_FROM_QUERY_PARAMS':
      return {
        ...state,
        dish: action.data,
      };

    case 'EDIT_DISH':
      return {
        ...state,
        creatingNewDish: action.newDish,
        selectedDish: action.data,
        showEditPopup: true,
        dish: action.payload.dish,
        tags: action.payload.tags,
        mealTypes: action.payload.mealTypes,
      };

    case 'CANCEL_EDIT_DISH':
      return {
        ...state,
        selectedDish: '',
        showEditPopup: false,
      };

    case 'EDIT_DISH_CREATE_SUCCESS':
      return {
        ...state,
        createNewDish: true,
        editSelectedDish: false,
        showEditPopup: false,
      };

    case 'EDIT_SELECTED_DISH_SUCCESS':
      return {
        ...state,
        createNewDish: false,
        editSelectedDish: true,
        showEditPopup: false,
      };

    case 'EDIT_SELECTED_DISH_ERROR':
      return {
        ...state,
        createNewDish: true,
        editSelectedDish: false,
        showEditPopup: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dishEdit.js